module.exports = __webpack_public_path__ + "img/salon-pet-friendly.9289ee4a.svg";